import * as React from 'react';

import { Alert, AlertTitle, Box, Paper, Typography } from '@mui/material';

import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';
import useGetIncidents from '../../core/api/hooks/incident/useGetIncidents';
import FormPaper from '../../components/FormPaper';
import IncidentDataGrid from '../../components/incident/IncidentDataGrid';
import UnattachedEventReports from '../../components/incident/UnattachedEventReports';

function IncidentFormHome(): JSX.Element {
  const { metadata, ...roles } = useAuthorizedFormData();
  const incidentsData = useGetIncidents([], 0);

  if (!metadata) {
    return (
      <Alert severity="error">
        <AlertTitle>Error - Metadata not found</AlertTitle>
      </Alert>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      <UnattachedEventReports hidden={!roles.isAdministrator} color={metadata.color} />
      { incidentsData.data && incidentsData.data?.length > 0 && (
      <FormPaper color={metadata.color}>
        <Box display="flex" alignItems="center" sx={{ mt: 1, mb: 2 }}>
          <Box display="flex" alignItems="center" flexGrow={1}>
            <Typography sx={{ mr: 2 }} variant="h5">
              All Incidents
            </Typography>
          </Box>
        </Box>
        <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
          <IncidentDataGrid data={incidentsData} reportType="incident" />
        </Paper>
      </FormPaper>
      )}
    </React.Fragment>
  );
}

export default IncidentFormHome;
